import axios from '../utils/axios';

export default function updatePotentialPaidJob(adminId, jobId, data) {
    return (
        axios.post(`/admin/${adminId}/job/${jobId}/update/potential-paid-job`,  data )
    );
}
